var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PolicyPopup',{ref:"policyPopupRef",attrs:{"show-check-box":false,"policy-content":_vm.privacyConfig.privacy_policy},on:{"confirm-policy":_vm.handleConfirmPolicy},model:{value:(_vm.checkedPrivacy),callback:function ($$v) {_vm.checkedPrivacy=$$v},expression:"checkedPrivacy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }